import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({
  name: 'dob'
})
export class DobPipe implements PipeTransform {

  transform(value: any,  mask: boolean = false, format? : string): any {
    if(!value)
      return value;
    else if(mask)
        return moment(value).format('MM') + '/' + moment(value).format('DD') + '/XXXX';
      else
          return moment(value).format('MM-DD-YYYY');
  }

}
